import { connect } from 'react-redux'
import orderSelector from '../selectors/orderSelector'
import SidebarSectionOrder from '../components/SidebarSectionOrder'
import SidebarSectionProduct from '../components/SidebarSectionProduct'

const mapStateToProps = (state) => {
  return {
    order: orderSelector(state)
  }
};

class NewOrderConfirmPricingForm extends React.Component {
  handleFormSubmit(event) {
    event.preventDefault();
    this.props.onSave();
  }

  render() {
    return (
      <form onSubmit={this.handleFormSubmit.bind(this)} className="form form-horizontal NewOrderConfirmPricingForm">
        <SidebarSectionProduct order={this.props.order} />
        <SidebarSectionOrder order={this.props.order} showOrderDetails={true} />

        <div className="form-group">
          <div className="form-actions order-description-button-sticky">
            <button type="submit" className="btn btn-lg btn-primary">{I18n.t("fe.NewOrderConfirmPricingForm.submit")}</button>
          </div>
        </div>
      </form>
    );
  }
}

const ConnectedNewOrderConfirmPricingForm = connect(
  mapStateToProps
)(NewOrderConfirmPricingForm)

export default ConnectedNewOrderConfirmPricingForm;



// WEBPACK FOOTER //
// ./app/webpack/frontend/features/NewOrderView/containers/NewOrderConfirmPricingForm.jsx